<template>
	<div
		class="bcw bcw__crop_distro"
		:class="{ 'zero--samples': flag.flagSamples }"
	>
		<header>
			<p class="title">
				{{ trans("dashboard.crop.title1") }}
				<span>{{ trans("dashboard.crop.title2") }}</span>
			</p>
			<p class="subtitle">{{ trans("dashboard.crop.sub") }}</p>
		</header>
		<main>
			<tabs :tabs="this.myTabs" @switchTabControl="switchActiveTab"></tabs>
			<div v-if="!loading" class="tab__content">
				<div class="chart__container">
					<barchart-3d :blocks="this.blocks" :opt="this.options"></barchart-3d>
				</div>
				<div class="list__container">
					<p class="subsec__title">{{ trans("dashboard.crop.top") }}</p>
					<list :list="this.blocks"></list>
				</div>
			</div>

			<div v-else class="crop__load">
				<loader :dim="64"></loader>
				<p>{{ trans("dashboard.general.retrieving") }}</p>
			</div>
		</main>
	</div>
</template>


<script>
import {trans} from "@common/tsutils/trans";

export default {
	props: ["widget", "flag"],

	data() {
		return {
			myTabs: [
				{
					id: "parcels",
					name: trans("dashboard.insiders.tabs.parcels"),
					active: true,
				},
				{
					id: "samples",
					name: trans("dashboard.insiders.tabs.samples"),
					active: false,
				},
			],

			activeTab: 0,

			options: {
				height: 200,
			},

			loading: false,

			blocks: this.buildBlocks(),
		};
	},

	methods: {
		switchActiveTab(i) {
			this.myTabs.forEach((tab) => {
				tab.active = false;
			});
			this.myTabs[i].active = true;
			this.activeTab = i;
			this.loadAsync();
		},

		async loadAsync() {
			this.loading = true;

			await this.widget.load(this.activeTab);

			this.blocks = this.buildBlocks();

			this.loading = false;
		},

		buildBlocks() {
			const data = this.widget.data(this.activeTab);

			let sortedBlocks = data.sort((a, b) => b.count - a.count);
			const groupedRestArr = sortedBlocks.slice(3, sortedBlocks.length - 1);
			const groupedRest = {
				count: 0,
				perc: 0,
				name: "Rest",
				logo_name: "bc",
				distrib: [],
			};

			groupedRestArr.forEach((element, i) => {
				groupedRest.count = groupedRest.count + element.count;
				groupedRest.distrib.push(element);
			});
			sortedBlocks = sortedBlocks.slice(0, 3);
			sortedBlocks.push(groupedRest);
			sortedBlocks.sort((a, b) => b.count - a.count);

			sortedBlocks.forEach((block, i) => {
				block.perc = block.count / sortedBlocks[0].count;
			});

			return sortedBlocks.filter((block) => block.count > 0);
		},
	},
};
</script>
